import React from 'react';
import './style.css';

const Panorama = () => {


    return (
        <div className="panorama-container">
            <div className="panorama-viewer">
                <iframe 
                    src="https://vr.justeasy.cn/view/9m17az5688u49577-1756886118.html"
                    // src="https://www.baidu.com"
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    allowFullScreen
                    title="VR全景展示"
                    referrerPolicy="no-referrer-when-downgrade"
                    sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                    style={{
                        border: 'none',
                        borderRadius: '0px',
                        minHeight: '600px'
                    }}
                    onError={(e) => console.log('iframe error:', e)}
                    onLoad={(e) => console.log('iframe loaded:', e)}
                />
            </div>
        </div>
    );
};

export default Panorama;